export default "__VITE_ASSET__06a68dc1__"